import { render, staticRenderFns } from "./TerminalAnswer.vue?vue&type=template&id=0c18e47e&scoped=true"
import script from "./TerminalAnswer.vue?vue&type=script&lang=js"
export * from "./TerminalAnswer.vue?vue&type=script&lang=js"
import style0 from "./TerminalAnswer.vue?vue&type=style&index=0&id=0c18e47e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../wscpet/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c18e47e",
  null
  
)

export default component.exports